import { FC, MouseEvent, PropsWithChildren } from "react";

type BreadcrumbLinkProps = {
  fetchAction: () => void;
} & PropsWithChildren;

export const BreadcrumbLink: FC<BreadcrumbLinkProps> = (props) => {
  const { children, fetchAction } = props;

  const handleOnClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    fetchAction();
  };

  return (
    <a
      href="/"
      className="link-light link-offset-2-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover"
      onClick={handleOnClick}
    >
      {children}
    </a>
  );
};
